import { FunctionComponent, useEffect, useState } from "react";
import { AccessControlGroup, UserAccessInfo, AccessGroupUserGroupRelation } from '../../types/accessControl';
import { Button, IconButton, Switch } from '../../tailwindcomponents';
import { Typography, Paper, Input, Dialog, Table, TableCell, TableRow } from './../../tailwindcomponents';
import { Datepicker } from '@mobiscroll/react';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import { AllInclusive } from '../../components/icons';
import AccessControlApi from '../../api/accessControl';
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import ProfileImg from "../../components/Images/ProfileImg";

type PermissionsProps = {
    groupsRelation: AccessGroupUserGroupRelation[],
    groupDetails: AccessControlGroup | undefined,
    permissions: UserAccessInfo[],
    setInGroupState: Function,
    inGroupState: boolean,
    refresh: Function,
    onUpdateGroupDetails: Function,
    tabValue: number,
    setLoading: Function,
}

const Permissions: FunctionComponent<PermissionsProps> = ({ tabValue, groupDetails, permissions, setInGroupState, inGroupState, refresh, onUpdateGroupDetails, setLoading }) => {
    const [areYouSureDialogOpen, setAreYouSureDialogOpen] = useState(false);
    const [employee, setEmployee] = useState<UserAccessInfo>();
    const [expirationDate, setExpirationDate] = useState<Date>(new Date());
    const [startsAt, setStartsAt] = useState<Date>(new Date());
    const [createdOrRemovedReason, setCreatedReason] = useState<string | undefined>(undefined);
    const [permissionId, setPermissionId] = useState<number | undefined>(undefined);
    const [usersInTable, setUsersInTable] = useState<UserAccessInfo[]>([]);
    const [employeeSearch, setEmployeeSearch] = useState<string>("");
    const store = useSelector((state: RootState) => state);
    const users = store.employees.all_employees.filter(s => s.visible === true);

    useEffect(() => {
        setUsersInTable(permissions);
        const escFunction = (event: any) => {
            //Select top users
            if (event.keyCode === 13 && usersInTable.length > 0) {
                if (inGroupState) {
                    setAreYouSureDialogOpen(true); setEmployee(usersInTable[0]); setPermissionId(usersInTable[0].permission_id);
                } else {
                    setAreYouSureDialogOpen(true); setEmployee(usersInTable[0]);
                }
            }
        }
        document.addEventListener('keydown', escFunction, false);
    }, [permissions]);

    const onAreYouDialogClicked = (status: boolean) => {
        if (status === true) {
            if (tabValue === 0) {
                if (inGroupState && (createdOrRemovedReason !== "" && createdOrRemovedReason !== undefined)) {
                    setLoading(true);
                    AccessControlApi.RemoveAccessGroupPermission(permissionId!, createdOrRemovedReason!).then(res => {
                        if (res.status) {
                            refresh();
                            onUpdateGroupDetails(groupDetails);
                            setLoading(false);
                            setAreYouSureDialogOpen(false);
                        }
                    });
                }
                else if (!inGroupState && (createdOrRemovedReason !== "" && createdOrRemovedReason !== undefined)) {
                    setLoading(true);
                    AccessControlApi.CreateAccessGroupPermission(groupDetails!.group_name, createdOrRemovedReason!, groupDetails!.id, employee!.employee_id, expirationDate, startsAt).then(res => {
                        if (res.status) {
                            refresh();
                            onUpdateGroupDetails(groupDetails);
                            setLoading(false);
                            setAreYouSureDialogOpen(false);
                        }
                    });
                }

            }
            else if (tabValue === 1) {
                if (inGroupState && (createdOrRemovedReason !== "" && createdOrRemovedReason !== undefined)) {
                    setLoading(true);
                    AccessControlApi.RemoveUserFromUserGroup(groupDetails!.id, employee!.employee_id, createdOrRemovedReason!).then(res => {
                        if (res.status) {
                            refresh();
                            onUpdateGroupDetails(groupDetails);
                            setLoading(false);
                            setAreYouSureDialogOpen(false);
                        }
                    });
                }
                else if (!inGroupState && (createdOrRemovedReason !== "" && createdOrRemovedReason !== undefined)) {
                    setLoading(true);
                    AccessControlApi.AddUserToUserGroup(createdOrRemovedReason!, groupDetails!.id, employee!.employee_id, expirationDate, startsAt).then(res => {
                        if (res.status) {
                            refresh();
                            onUpdateGroupDetails(groupDetails);
                            setLoading(false);
                            setAreYouSureDialogOpen(false);
                        }
                    });
                }

            } else {
                setAreYouSureDialogOpen(false);
            }
        }
        else if (status === false) {
            setAreYouSureDialogOpen(false);
        }
    }
    const onShowEmployeeStatus = (value: string) => {
        setEmployeeSearch(value);
        const filteredUsers: UserAccessInfo[] = permissions.filter(x => x.name.toLowerCase().includes(value.toLowerCase()));
        setUsersInTable(filteredUsers);
    }

    const generateTableBody = (row: UserAccessInfo,  index: number) => {
        return (
            <TableRow>
                <TableCell>
                    <div className="flex flex-wrap">
                        <ProfileImg imgKey={index} userName={users.find(s => s.Id === row.employee_id)?.userName?.split('@')[0]} />
                    </div>
                </TableCell>
                <TableCell> {row.name} </TableCell>
                <TableCell> {row.job_title} </TableCell>
                <TableCell> {row.starts_at} </TableCell>
                <TableCell> {row.expiration_date} </TableCell>
                <TableCell>
                    {inGroupState ?
                        <Button variant="contained" color='secondary' onClick={() => { setAreYouSureDialogOpen(true); setEmployee(row); setPermissionId(row.permission_id) }}>Remove</Button>
                        :
                        <Button variant="contained" color='primary' onClick={() => { setAreYouSureDialogOpen(true); setEmployee(row) }}>Insert</Button>
                    } </TableCell>
            </TableRow>
        )
    }
    return (
        <div>
            <div className="p-2 mb-8">
                <Paper elevation={16} >
                    {groupDetails ?
                        <div className="flex flex-row flex-wrap items-center gap-4 ml-2">
                            <Typography align="center" alignSelf="center" fontWeight="bold" text={groupDetails.group_name} />
                            <Typography text={"In group"} />
                            <Switch
                                checked={!inGroupState}
                                onChange={() => setInGroupState()}
                                color="secondary"
                            />
                            <Typography text={"Not in group"} />
                            <div className="w-1/4">
                                <Input
                                    multiline={false}
                                    label_text=""
                                    help_text=""
                                    type="text"
                                    value={employeeSearch}
                                    width={100}
                                    onTextChange={(value: string) => onShowEmployeeStatus(value)}
                                />
                            </div>
                        </div>
                        : <div className="p-4 ml-2 text-[20px]">Select a group to view permission</div>
                    }
                    {groupDetails !== undefined &&
                        <div>
                            <Table
                                headers={["IMAGE", "FULL NAME", "JOB TITLE", "STARTS AT", "EXPIRES AT", `${!inGroupState ? "INSERT" : "REMOVE"}`]}
                                rows={usersInTable}
                                generateBody={(row: any, index: number) => generateTableBody(row, index)}
                                pagination={true}
                                defaultRowsPerPage={10}
                                skipIndexCol={true}
                            />
                        </div>
                    }
                </Paper>
            </div>
            <Dialog
                visible={areYouSureDialogOpen}
                max_width={"md"}
                title={`${inGroupState ? `Are you sure you want to remove ${employee?.name} from group` : `Are you sure you want to insert ${employee?.name} to group`}`}
                context={
                    <div className="flex flex-row flex-wrap">
                        <Input
                            multiline={false}
                            label_text="Reason"
                            help_text="Please give a reason for privileges"
                            type="text"
                            value={createdOrRemovedReason}
                            width={100}
                            onTextChange={(value: string) => setCreatedReason(value)}
                        />
                        {!inGroupState &&
                            <div  >
                                <div className="mb-2 mt-4">
                                    <div className="flex flex-row flex-wrap items-center gap-2">
                                        <Typography text={"Expiration date"} />
                                        <Datepicker
                                            controls={['calendar']}
                                            inputProps={{
                                                placeholder: 'Select date'
                                            }}
                                            display='anchored'
                                            touchUi={true}
                                            value={expirationDate}
                                            onChange={(e: any) => setExpirationDate(e.value)}
                                            themeVariant='light'
                                            dateFormat='DD.MM.YYYY'
                                        />
                                        <IconButton onClick={() => { setExpirationDate(new Date("01.01.2099")); setCreatedReason("Permanent permission"); }}><AllInclusive /></IconButton>
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <div className="flex flex-row flex-wrap items-center gap-2">
                                        <Typography text={"Starts at"} />
                                        <Datepicker
                                            controls={['calendar']}
                                            inputProps={{
                                                placeholder: 'Select date'
                                            }}
                                            display='anchored'
                                            touchUi={true}
                                            value={startsAt}
                                            onChange={(e: any) => setStartsAt(e.value)}
                                            themeVariant='light'
                                            dateFormat='DD.MM.YYYY'
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
                onClose={(status: any) => onAreYouDialogClicked(status)}
                strict={false}
                show_options={true}
            />
        </div >
    )
}

export default Permissions;